import React from 'react';
import { Button } from 'components/Button';
import { ReturnSettlementActionState } from './returnSettlementAction';

type ReturnSettlementActionControlProps = {
  actionId: string;
  actionState: ReturnSettlementActionState;
  className: string;
  isLoading?: boolean;
  onClick: () => void;
};

export const ReturnSettlementActionControl = ({
  actionId,
  actionState,
  className,
  isLoading = false,
  onClick,
}: ReturnSettlementActionControlProps) => {
  const instructionId = `${actionId}-instruction`;
  const showLoading = isLoading && !actionState.isOutcomeUnknown;

  return (
    <div className="flex flex-col items-end gap-2">
      <Button
        onClick={onClick}
        className={className}
        isLoading={showLoading}
        disabled={actionState.disabled}
        props={{
          id: actionId,
          'aria-busy': actionState.isBusy,
          'aria-describedby': actionState.instruction
            ? instructionId
            : undefined,
        }}
      >
        {actionState.label}
      </Button>

      {actionState.instruction && (
        <p
          id={instructionId}
          className="max-w-md text-right text-xs font-medium text-amber-700"
          role="status"
        >
          {actionState.instruction}
        </p>
      )}
    </div>
  );
};
